export const formatMoney = (value, currency = "EUR") =>
    new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(
        Number.isFinite(value) ? value : 0
    );

export const toNumber = (value) => {
    const normalized = typeof value === "string" ? value.replace(",", ".") : value;
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const emptyShippingCost = () => ({
    id: "",
    name: "",
    price: "",
    taxRate: 19,
    active: true,
});

export const TAX_RATES = [19, 7, 0];

export const getShippingCostGroupKey = (shippingCost) => {
    const candidate = (shippingCost?.name || "").trim();
    if (!candidate) {
        return "#";
    }
    const letter = candidate.slice(0, 1).toUpperCase();
    return /^[A-ZÄÖÜ]$/.test(letter) ? letter : "#";
};
